export default {
  getEmployeeHomeDetails: 'GET_EMPLOYEE_HOME_DETAILS',
  getEmployeeHomeDetailsSuccess: 'GET_EMPLOYEE_HOME_DETAILS_SUCCESS',
  getEmployeeHomeDetailsFailed: 'GET_EMPLOYEE_HOME_DETAILS_FAILED',
  placeOrder: 'PLACE_ORDER',
  placeOrderSuccess: 'PLACE_ORDER_SUCCESS',
  placeOrderFailed: 'PLACE_ORDER_FAILED',
  cancelOrder: 'CANCEL_ORDER',
  cancelOrderSuccess: 'CANCEL_ORDER_SUCCESS',
  cancelOrderFailed: 'CANCEL_ORDER_FAILED',
  resetToInitialState: 'EMPLOYEE_HOME_RESET_TO_INITIAL_STATE',
};
